import { Component, ContentChild, Input, TemplateRef } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { EoTableComponent } from '../eo-table/eo-table.component';
import { TableConfig } from '../model/config/table-config.model';

@Component({
  selector: 'eo-table-row-expansion',
  templateUrl: './eo-table-row-expansion.component.html',
  styleUrl: './eo-table-row-expansion.component.scss',
  animations: [
      trigger('rowExpansionTrigger', [
          state('void', style({
              transform: 'translateX(-10%)',
              opacity: 0
          })),
          state('active', style({
              transform: 'translateX(0)',
              opacity: 1
          })),
          transition('* <=> *', animate('400ms cubic-bezier(0.86, 0, 0.07, 1)'))
      ])
  ]
})
export class EoTableRowExpansionComponent<T> extends EoTableComponent<T>{

  @Input() ConfigExpansionComponent: TableConfig<T> | undefined;
  @Input() items: any[] = [];
  @ContentChild('expandTemplate', { static: true }) expandTemplate!: TemplateRef<any>;

  constructor() {
    super();
   }
}
